import type { RecoilValue } from "recoil";

type Nexus = {
  get?: <T>(atom: RecoilValue<T>) => T;
};

const nexus: Nexus = {};

export const getNexusInstance = (): Nexus => nexus;
